import React from "react";
import { AlertCircle, CheckCircle2, Info, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@shadcn-in-nx/ui/alert";

function Message({ info, success, warning, error, children, className }) {
    let variant = "default";
    let icon = <Info className="h-4 w-4" />;
    let title = "Info";
    let bgClass = "bg-gray-100"; // default gray background for info

    if (success) {
        variant = "success";
        icon = <CheckCircle2 className="h-4 w-4" />;
        title = "Success";
        bgClass = "";
    } else if (warning) {
        variant = "warning";
        icon = <AlertTriangle className="h-4 w-4" />;
        title = "Warning";
        bgClass = "bg-yellow-50"; // light yellow background for warning
    } else if (error) {
        variant = "destructive";
        icon = <AlertCircle className="h-4 w-4" />;
        title = "Error";
        bgClass = "";
    }

    return (
        <Alert variant={variant} className={`${bgClass} ${className}`}>
            {icon}
            <AlertTitle>{title}</AlertTitle>
            <AlertDescription>{children}</AlertDescription>
        </Alert>
    );
}
export default Message;
